import { useEffect, useState } from "react";
import { buildTicker } from "@/lib/display";

export default function DisplayTicker({ snapshot }) {
  const [, setT] = useState(0);
  useEffect(() => {
    const i = setInterval(() => setT((x) => x + 1), 1000);
    return () => clearInterval(i);
  }, []);

  const large = snapshot.settings?.display_mode === "large";
  const segs = buildTicker(snapshot);
  const text = segs.join("        •        ");

  if (!text) return null;

  return (
    <div className={`${large ? "h-[104px]" : "h-[64px]"} bg-[#E5FF00] text-black flex items-center overflow-hidden shrink-0`} data-testid="display-ticker">
      <div className={`marquee-track font-display font-bold uppercase tracking-wider ${large ? "text-5xl" : "text-3xl"}`}>
        <span className="px-12">{text}</span>
        <span className="px-12">{text}</span>
      </div>
    </div>
  );
}
